import { DepartmentPage } from '@/pages/Department/DepartmentPage';
import { HomePage } from '@/pages/Home/HomePage';
import { NotFoundPage } from '@/pages/NotFound/NotFoundPage';
import { ROUTES } from '@/dictionary/routes';
import { useScrollToAnchor } from '@/hooks/useScrollToAnchor';
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

/* עמודי תוכן נטענים בעצלתיים כדי לשמור על חבילה ראשונית קטנה */
const AboutPage = lazy(() =>
  import('@/pages/About/AboutPage').then((module) => ({ default: module.AboutPage })),
);
const AdvisorsPage = lazy(() =>
  import('@/pages/Advisors/AdvisorsPage').then((module) => ({ default: module.AdvisorsPage })),
);
const TracksPage = lazy(() =>
  import('@/pages/Tracks/TracksPage').then((module) => ({ default: module.TracksPage })),
);
const TermsPage = lazy(() =>
  import('@/pages/Terms/TermsPage').then((module) => ({ default: module.TermsPage })),
);

export function App() {
  useScrollToAnchor();

  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path={ROUTES.home} element={<HomePage />} />
        <Route path={ROUTES.department} element={<DepartmentPage />} />
        <Route path={ROUTES.about} element={<AboutPage />} />
        <Route path={ROUTES.advisors} element={<AdvisorsPage />} />
        <Route path={ROUTES.tracks} element={<TracksPage />} />
        <Route path={ROUTES.terms} element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
